import { dateRangeZodObject } from "@@/shared/date-time/date-range";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { headQuoteItemZodSchema } from "@@/shared/quotes/quote";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";

const recipientsZodObject = z.object({
    userId: userIdZodSchema.optional(),
    name: z.string(),
    email: z.string().email(),
    phone: z.string().optional(),
});

const quoteBaseZodObject = z.object({
    title: translatableZodSchema,
    reference: z.string(),
    valid: dateRangeZodObject,

    //Customers eller participants?
    recipients: z.array(recipientsZodObject),

    /**Figure what is need here, gäller vem det är för */
    customer: contactInfoZodObject,

    items: z.array(headQuoteItemZodSchema),
});

type QuoteBase = z.infer<typeof quoteBaseZodObject>;

export { quoteBaseZodObject, recipientsZodObject };
export type { QuoteBase };
